<template>
  <div class="flex items-center flex-shrink-0 text-black mr-6">
    <div class="flex p-4" v-if="!isPreview">
      <button
        id="showSideBar"
        @click="openOutlineMenu()"
        class="sm:inline md:hidden bg-white text-gray-700 text-xl"
      >
        <i class="fas fa-bars"></i>
      </button>
    </div>
    <div class="p-4 hidden md:flex" v-if="navLogo">
      <span
        style="max-height: 40px; max-width: 130px"
        @click="!isPreview ? gotToHome : null"
        ><img :src="navLogo" class="h-full object-cover" alt=""
      /></span>
    </div>

    <div
      v-if="isMenuOpen"
      class="md:hidden absolute z-50 w-full left-0 p-4 background-dark"
      style="top: 45px"
    >
      <MembershipOutline
        class="overflow-hidden shadow"
        :membershipOutline="membershipOutline"
        :changePage="changePage"
        :isPreview="isPreview"
      />
    </div>
  </div>
</template>
<script>
import MembershipOutline from '../left-panel/membership-outline';
import { Bus } from '../../main';
export default {
  name: 'NavbarLogo',
  data() {
    return {
      isMenuOpen: false,
      mobileScreen: false
    };
  },
  components: {
    MembershipOutline
  },
  created() {
    window.addEventListener('resize', this.isMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile);
  },
  mounted() {
    Bus.$on('close-h-menu', () => {
      if (this.mobileScreen) {
        console.log('close-h-menu');
        this.isMenuOpen = !this.isMenuOpen;
        const elementSidebar = document.getElementById('showSideBar');
        const mainBody = document.getElementById('main-body-area');
        if (this.isMenuOpen) {
          elementSidebar.innerHTML = '<i else class="fas fa-times"></i>';

          mainBody.style.zIndex = -999;
          mainBody.style.opacity = 0.1;
        } else {
          elementSidebar.innerHTML = '<i else class="fas fa-bars"></i>';
          mainBody.style.zIndex = 1;
          mainBody.style.opacity = 1;
        }
      }
    });
  },

  props: ['navLogo', 'isPreview', 'membershipOutline', 'changePage'],
  methods: {
    isMobile(e) {
      console.log(screen.width, 'screen.width');
      if (screen.width < 760) {
        this.mobileScreen = true;
      } else {
        this.mobileScreen = false;
      }
    },
    openOutlineMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      const elementSidebar = document.getElementById('showSideBar');
      const mainBody = document.getElementById('main-body-area');
      if (this.isMenuOpen) {
        elementSidebar.innerHTML = '<i else class="fas fa-times"></i>';

        mainBody.style.zIndex = -999;
        mainBody.style.opacity = 0.1;
      } else {
        elementSidebar.innerHTML = '<i else class="fas fa-bars"></i>';
        mainBody.style.zIndex = 1;
        mainBody.style.opacity = 1;
      }
    }
  }
};
</script>
<style>
/* .background-dark {
  background-color: rgba(75, 73, 73, 0.8);
} */
</style>
